/// <amd-module name="VSS/Features/Frame/AssetResolver/index" />
export * from "./AssetResolver";
